import { Linkedin, Twitter, Mail, Link2, Check } from 'lucide-react';
import { useState } from 'react';

const ShareButtons = ({ url, title, summary, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(url || window.location.href);
  const encodedTitle = encodeURIComponent(title || document.title);
  const encodedSummary = encodeURIComponent(summary || '');

  const share = (platform) => {
    const urls = {
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      email: `mailto:?subject=${encodedTitle}&body=${encodedSummary}%0A%0A${encodedUrl}`,
    };
    if (platform === 'email') {
      window.location.href = urls[platform];
    } else {
      window.open(urls[platform], '_blank', 'width=600,height=500');
    }
  };

  const copyLink = () => {
    const textToCopy = url || window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }).catch(() => {
        fallbackCopy(textToCopy);
      });
    } else {
      fallbackCopy(textToCopy);
    }
  };

  const fallbackCopy = (text) => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (compact) {
    return (
      <div className="flex items-center gap-1" data-testid="share-buttons">
        <button onClick={() => share('linkedin')} title="Share on LinkedIn"
          className="p-2 rounded-lg bg-[#0077B5]/10 text-[#0077B5] hover:bg-[#0077B5]/20 transition-colors" data-testid="share-linkedin">
          <Linkedin className="w-4 h-4" />
        </button>
        <button onClick={() => share('twitter')} title="Share on X/Twitter"
          className="p-2 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors" data-testid="share-twitter">
          <Twitter className="w-4 h-4" />
        </button>
        <button onClick={() => share('email')} title="Share via Email"
          className="p-2 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors" data-testid="share-email">
          <Mail className="w-4 h-4" />
        </button>
        <button onClick={copyLink} title="Copy link"
          className="p-2 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors" data-testid="share-copy">
          {copied ? <Check className="w-4 h-4 text-emerald-500" /> : <Link2 className="w-4 h-4" />}
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="text-2xs font-bold text-slate-400 uppercase tracking-wider">Share</span>
      <button onClick={() => share('linkedin')} title="Share on LinkedIn"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-[#0077B5] text-white hover:bg-[#006097] transition-colors" data-testid="share-linkedin">
        <Linkedin className="w-3.5 h-3.5" /> LinkedIn
      </button>
      <button onClick={() => share('twitter')} title="Share on X/Twitter"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-800 text-white hover:bg-slate-700 transition-colors" data-testid="share-twitter">
        <Twitter className="w-3.5 h-3.5" /> X
      </button>
      <button onClick={() => share('email')} title="Share via Email"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors" data-testid="share-email">
        <Mail className="w-3.5 h-3.5" /> Email
      </button>
      <button onClick={copyLink} title="Copy link"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors" data-testid="share-copy">
        {copied ? <><Check className="w-3.5 h-3.5 text-emerald-500" /> Copied!</> : <><Link2 className="w-3.5 h-3.5" /> Copy Link</>}
      </button>
    </div>
  );
};

export default ShareButtons;
